<template>
    <div class="wechat-order">
        <div class="tableConBox">
            <div class="tableTem">
                <div class="HSpace1"></div>
                <div class="searchBox flex flex-align-center">
                    <div class="searchCon clearfix">
                        <div class="left searchBtn" style="margin-left:10px;">
                            <button type="button" @click="codeBtn = true;">添加微信点单</button>
                        </div>
                        <div class="left searchBtn" style="margin-left:10px;">
                            <button type="button" @click="out">批量导出</button>
                        </div>
                    </div>
                </div>
                <div class="HSpace2">&nbsp;</div>
                <div class="tableBox">
                    <div class="tableBoxScroll">
                        <table class="titleTable">
                            <tr>
                                <th style="width:8%">序号</th>
                                <th style="width:11%">桌号</th>
                                <th style="width:13%">二维码</th>
                                <th style="width:11%">添加时间</th>
                                <th style="width:10%">操作</th>
                            </tr>
                        </table>
                        <div class="scrollBox">
                            <div class="scroll">
                                <table class="conTable" :class="{overLengthTable:wechatList.length>pageSize}">
                                    <tr v-for="(item,index) in wechatList" :key="index" class="listTr">
                                        <td style="width:8%">{{item.id?((index+1)+(nowPage-1)*pageSize):""}}</td>
                                        <td style="width:11%">{{item.id?decodeURIComponent(item.name):""}}</td>
                                        <td style="width:13%;">
                                            <span @click="showCodeImg(item)" style="color:blue;cursor:pointer;" v-if="item.id">查看</span>
                                        </td>
                                        <td style="width:11%">{{item.addTime | dateForGradePage}}</td>
                                        <td style="width:10%;" >
                                            <span class="change" @click="doChange(item)"><i style="color:#333" class="iconfont icon-bianji" v-if="item.id"></i></span>
                                            <span class="del" @click="doActive(item)"><i style="color:#333" class="iconfont icon-icon1460188478041" v-if="item.id"></i></span>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="text-align:right;">
                    <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page.sync="nowPage"
                        :page-size="pageSize"
                        layout="total, prev, pager, next"
                        :total="totalElements">
                    </el-pagination>
                </div>
            </div>
            
        </div>
        <el-dialog
            title="微信点单"
            class="codes"
            :visible.sync="codeBtn"
            v-loading.body="infoload"
            size="tiny">
            <div class="msgBox clearfix">
                <div class=" msgItem clearfix">
                    <span class="left itemName"><i>*</i>桌号</span>
                    <input type="text" class="left itemInput" v-model="tableNo" placeholder="请输入桌号" >
                </div>
                <!-- <div class=" msgItem clearfix">
                    <span class="left itemName"><i>*</i>记录名字</span>
                    <input type="text" class="left itemInput" v-model="name" placeholder="请输入记录名字">
                </div> -->
            </div>
            <span slot="footer" class="dialog-footer">
                <button type="button" @click="codeBtn=false" class="cancel">取消</button>
                <button type="button" @click="addWechatOrder" class="save">保存</button>
            </span>
        </el-dialog>
        <el-dialog
            :title="'打开微信可扫描二维码'"
            class="codes"
            :visible.sync="showCode"
            v-loading.body="infoload"
            size="tiny">
            <!-- <div style="color:red;margin-top:10px;font-size:12px;text-align:center;position:absolute;top:8px;left:7em;" v-if="!isSendCodeBtn">
                <span >验证码已发送到老板手机号</span>
            </div> -->
            <div  style="color:red;font-size:12px;text-align:center;margin-bottom:10px;">
                <span>保存为图片(建议使用谷歌浏览器，如使用的360等浏览器，请打开极速模式。)</span>
            </div>
            <div class="inner-wrap">
                <div class="inners" id="img-info">
                    <div class="inner-top">
                        <div class="inner-tit">扫码点餐买单</div>
                        <div class="code-wrap">
                            <div id="qrcode"></div>
                        </div>
                        <div class="table-code">{{codeInfo}}</div>
                    </div>
                    <div class="inner-bot">
                        <div class="code-info">
                            <span class="wechat"><i class="iconfont icon-weixinzhifu"></i><b>微信支付</b></span>
                            <span class="huoxing"><i class="iconfont icon-huoxingbushoulogo"></i><b>火星捕手</b></span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="save-img">
                <a href="" id="down-img" download="">保存图片</a>
            </div>
        </el-dialog>
        <div class="inner-wrap-all" style="height:0px;overflow:hidden;">
        <!-- <div class="inner-wrap-all"> -->
            <div class="inners" id="img-info-all">
                <div class="inner-top">
                    <div class="inner-tit">扫码点餐买单</div>
                    <div class="code-wrap">
                        <div class="qr-code-img-wrap" id="qrcode-all"></div>
                    </div>
                    <div class="table-code">{{nowCodeName}}</div>
                </div>
                <div class="inner-bot">
                    <div class="code-info">
                        <span class="wechat"><i class="iconfont icon-weixinzhifu"></i><b>微信支付</b></span>
                        <span class="huoxing"><i class="iconfont icon-huoxingbushoulogo"></i><b>火星捕手</b></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="mask" v-if="!isOutSuc">
            <div class="mask-info">
                请稍等...正在打包中...({{count}}/{{allCodeList.length}})
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
import JSZip from 'jszip'
import FileSaver from 'file-saver'
    export default{
        props: ['curStoreId','pageSize','storeData'],
    	data () {
    		return {
                count:0,
                nowCodeName:"",//当前二维码的名称
                isOuting:true,//正在导出中
                isOutSuc:true,
                allCodeList:[],//所有的二维码地址
                codeInfo:"",
                wechatList:[],
                infoload: false, // loading
                codeBtn:false,
                tableNo:"",
                name:"",
                showCode:false,
                totalElements:0,
                nowPage:0,
                curItem:{id:null}
    		}
        },
        watch:{
            codeBtn(val){
                if(!val){
                    console.log(val)
                    this.curItem = {id:null};
                    this.tableNo = "";
                }
            },
            // nowPage(val){
            //     for(let i=0;i<this.wechatList.length;i++){
            //         document.getElementById("qrcode-"+i).innerHTML = ""
            //         setTimeout(()=>{
            //             let qrcode = new QRCode("qrcode-"+i, {
            //                 text: this.wechatList[i].url,
            //                 colorDark : "#000000",
            //                 colorLight : "#ffffff",
            //                 correctLevel : QRCode.CorrectLevel.H
            //             });
            //         },500);
            //     }
            // }
        },
        methods: {
            saveImg(){
                // html2canvas($("#img-info"),{
                //     height: $("#img-info").outerHeight() + 20,  
                //     width: $("#img-info").outerWidth() + 20  ,
                //     onrendered: function(canvas) {
                //         //将canvas画布放大若干倍，然后盛放在较小的容器内，就显得不模糊了
                //         var timestamp = Date.parse(new Date());
                //         //把截取到的图片替换到a标签的路径下载  
                //         $("#down-img").attr('href',canvas.toDataURL());  
                //         //下载下来的图片名字  
                //         $("#down-img").attr('download',timestamp + '.png');
                //     }
                // });
                html2canvas(document.querySelector("#img-info")).then(function(canvas) {
                    $("#down-img").attr('href',canvas.toDataURL()); 
                    let timestamp = Date.parse(new Date());
                    $("#down-img").attr('download',timestamp + '.png');
                });
            },
            // 批量导出start
            outAll(){
                // 首先获取所有的二维码地址
                this.$http({
                    url:"url-order",
                    method:"GET",
                    params:{
                        storeId:this.curStoreId,
                        page:0,
                        size:500
                    }
                }).then(res=>{
                    this.allCodeList = res.data.content;
                });
            },
            async out(){

                this.isOutSuc = false;
                const zip = new JSZip();
                const cache = {}
                const arr = [];
                let allCodeList = [];
                this.count = 0;

                for(let i=0;i<this.allCodeList.length;i++){
                    if(this.allCodeList[i].id){
                        allCodeList.push(this.allCodeList[i]);
                    }
                }
                let forDrawRes = await this.forDraw(allCodeList,cache,arr,zip);

                console.log("------------------------------------")
                console.log(cache)

                await this.doPackge(zip);
            },
            async forDraw(allCodeList,cache,arr,zip){
                for(let i=0;i<allCodeList.length;i++){
                    console.log(decodeURIComponent(allCodeList[i].name))
                    this.nowCodeName = decodeURIComponent(allCodeList[i].name);
                    // 生成二维码
                    console.log("生成二维码");
                    let codeRes = await this.createCode(allCodeList[i]);
                    // 画图
                    console.log("画图");
                    let canvas = await this.drawImg();
                    // 存储在对象中
                    console.log("存储在对象中");
                    // console.log(canvas);
                    let saveRes = await this.savePack(allCodeList[i],cache,canvas,arr,zip,i);
                    this.count++;
                }
                // 有时候会出现第一个名字打印出错，重新打印
                if(allCodeList.length){
                    console.log(decodeURIComponent(allCodeList[0].name))
                    this.nowCodeName = decodeURIComponent(allCodeList[0].name);
                    // 生成二维码
                    console.log("生成二维码");
                    let codeRes = await this.createCode(allCodeList[0]);
                    // 画图
                    console.log("画图");
                    let canvas = await this.drawImg();
                    // 存储在对象中
                    console.log("存储在对象中");
                    // console.log(canvas);
                    let saveRes = await this.savePack(allCodeList[0],cache,canvas,arr,zip,0);
                }
            },
            //打包    
            savePack(item,cache,canvas,arr,zip,i){
                let timestamp = Date.parse(new Date());
                // let file_name = decodeURIComponent(item.name)+'_'+timestamp; // 获取文件名
                let file_name = decodeURIComponent(item.name); // 获取文件名
                zip.file(file_name+'.png', canvas.toDataURL('image/jpeg').replace('data:image/jpeg;base64,',''), {
                    base64: true,
                });
                // 逐个添加文件
                cache[file_name] = canvas
                // console.log(cache);
                // arr.push(i);
            },
            // 生成二维码
            async createCode(item){
                let doCode = (item)=>{
                    document.getElementById("qrcode-all").innerHTML = ""
                    let qrcode = new QRCode("qrcode-all", {
                        text: item.url,
                        width: 200,
                        height: 200,
                        colorDark : "#000000",
                        colorLight : "#ffffff",
                        correctLevel : QRCode.CorrectLevel.H
                    });
                }
                return await doCode(item);
            },
            // 画图
            async drawImg(){
                let doRraw = ()=>{
                    return html2canvas(document.querySelector("#img-info-all")).then((canvas)=> {
                        // canvas.width = 200;
                        // canvas.height = 200;
                        return Promise.resolve(canvas);
                    });
                }
                return await doRraw();
            },
            // 批量导出end
            doChange(item){
                this.codeBtn = true;
                this.tableNo = decodeURIComponent(item.name);
                this.curItem = item;
            },
            // 打包
            doPackge(zip){
                console.log(zip)
                // 打包
                zip.generateAsync({
                    type: "blob"
                }).then(content => { // 生成二进制流
                    FileSaver.saveAs(content, "qrcode.zip") // 利用file-saver保存文件
                })
                this.isOutSuc = true;
            },
            handleCurrentChange(val){
                this.getWechatList(val - 1);
                this.nowPage = val;
            },
            showCodeImg(item){
                this.showCode = true;
                this.codeInfo = decodeURIComponent(item.name);
                // this.codeInfo = item.name;
                setTimeout(()=>{
                    $('#qrcode')[0].innerHTML='';
                },300);

                setTimeout(()=>{
                    let qrcode = new QRCode("qrcode", {
                        text: item.url,
                        colorDark : "#000000",
                        colorLight : "#ffffff",
                        correctLevel : QRCode.CorrectLevel.H
                    });
                },500);

                setTimeout(()=>{
                    this.saveImg();
                },1000);
            },
            addWechatOrder(){
                if(!this.tableNo){
                    this.$message({
                        message: '请填写桌号',
                        customClass: 'error'
                    });
                    return;
                }
                this.$http({
                    url:"url-merge",
                    method:"POST",
                    data:{
                        id:this.curItem.id?this.curItem.id:0,
                        storeId:this.curStoreId,
                        tableNo:encodeURIComponent(this.tableNo),
                        name:encodeURIComponent(this.tableNo),
                    }
                }).then(res=>{
                    if(res.data.code == 200){
                        this.$message({
                            message: res.data.msg,
                            customClass: 'success'
                        });
                        this.curItem = {id:null};
                        this.tableNo = "";
                        this.codeBtn = false;
                        this.getWechatList(this.nowPage - 1);
                    }else if(res.data.code == 400){
                        this.$message({
                            message: res.data.msg,
                            customClass: 'error'
                        });
                    }
                    
                });
            },
            doActive(item){                
                this.$confirm('此操作将删除该桌号的微信点单, 确认此操作?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                    this.$http({
                        url:"url-delete",
                        method:"POST",
                        data:{
                            id:item.id,
                        }
                    }).then(res=>{
                        this.$message({
                            message: '操作成功',
                            customClass: 'success'
                        });
                        this.getWechatList(this.nowPage - 1);
                    });
                }).catch(() => {});
            },
            getWechatList(page){
                this.$http({
                    url:"url-order",
                    method:"GET",
                    params:{
                        storeId:this.curStoreId,
                        page,
                        size:this.pageSize
                    }
                }).then(res=>{
                    this.wechatList = res.data.content;
                    this.totalElements = res.data.totalElements;
                    let number = this.pageSize - this.wechatList.length;
                    if ( number > 0 ) {
                        for (let i = 0; i < number; i++) {
                            this.wechatList.push({});
                        }
                    }
                    this.outAll();
                });
            }
        },
        activated: function () {
            for (let i = 0; i < this.pageSize; i++) {
                this.wechatList.push({})
            }
           
            this.getWechatList(0);
        },
        mounted: function () {
            // this.outAll();
            // 改变关闭样式
            $(document).ready(()=>{
                $('.el-dialog__headerbtn i').attr('class', 'el-dialog__close iconfont icon-guanbi');
            });
        }
    }
</script>
<style lang="scss">
    @import '../../../../static/css/common.scss';
    @import '../../tableTemplate/tableTem.scss';
    @import '../../tableTemplate/el-dialog.scss';
	@import "./wechatOrder.scss";
</style>



// WEBPACK FOOTER //
// wechatOrder.vue?af5e9384